import { render, staticRenderFns } from "./BalancePopup.vue?vue&type=template&id=f631aade&scoped=true"
import script from "./BalancePopup.vue?vue&type=script&lang=ts"
export * from "./BalancePopup.vue?vue&type=script&lang=ts"
import style0 from "./BalancePopup.vue?vue&type=style&index=0&id=f631aade&prod&lang=scss&scoped=true"
import style1 from "./BalancePopup.vue?vue&type=style&index=1&id=f631aade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f631aade",
  null
  
)

export default component.exports